module.exports = __webpack_public_path__ + "img/icon_minus_default .aba83116.svg";